import styled from 'styled-components';

export const CalendarDayCell = styled.div`
    overflow: visible;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 2px 0px;
`;
